import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, Filter } from "lucide-react";
import TableComponent from "../../../shared/components/table";
import { PresidentPanelsColumns } from "../../../shared/components/table/columns/presidentPanelsColumns";
import { SortingState } from "@tanstack/react-table";

const panelInnerTabs = ["All Judges", "By Panels"];

const panelData = [
  {
    sn: 1,
    panel_name: "Panel A",
    judges: [
      "Hon. Justice Esther Ochendo",
      "Hon. Justice Mba",
      "Hon. Justice Eze",
    ],
    admin: "Admin",
    court_number: "Court 2",
    subject_matter: "Criminal",
    status: "Active",
    docket: "",
  },
  {
    sn: 2,
    panel_name: "Panel B",
    judges: [
      "Hon. Justice Esther Ochendo",
      "Hon. Justice Mba",
      "Hon. Justice Eze",
    ],
    admin: "Admin",
    court_number: "Court 3",
    subject_matter: "Civil",
    status: "Active",
    docket: "",
  },
  {
    sn: 3,
    panel_name: "Panel C",
    judges: [
      "Hon. Justice Esther Ochendo",
      "Hon. Justice Mba",
      "Hon. Justice Eze",
    ],
    admin: "Admin",
    court_number: "Court 4",
    subject_matter: "Civil",
    status: "Active",
    docket: "",
  },
];

function Panels() {
  const [activePanelInnerTab, setActivePanelInnerTab] =
    useState("All Judges");
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="flex flex-col h-full min-h-screen">
      {/* Header */}
      <div className="bg-white px-8 py-6 border-b border-[#E9EAEB]">
        <div className="flex items-center gap-x-2 text-sm text-[#464255] mb-4">
          <Link to="/president/overview" className="hover:text-[#00B074]">
            Home
          </Link>
          <span>&gt;</span>
          <span className="font-medium text-[#1A1A1A]">Panels</span>
        </div>
        <h1 className="text-2xl font-bold text-[#1A1A1A]">Panels</h1>
      </div>

      {/* Inner tabs */}
      <div className="bg-white border-b border-[#E9EAEB] px-8 pt-4">
        <div className="flex items-center gap-8 text-sm font-medium">
          {panelInnerTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActivePanelInnerTab(tab)}
              className={`pb-3 border-b-2 ${
                activePanelInnerTab === tab
                  ? "border-[#111827] text-[#111827]"
                  : "border-transparent text-[#667085]"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Search and filters */}
      <div className="px-8 py-6 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div className="relative w-full max-w-[320px]">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#E5E7EB] focus:outline-none focus:border-[#111827] bg-white text-sm"
            />
            <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9CA3AF]" />
          </div>

          <button className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-[#D0D5DD] bg-white text-sm font-medium text-[#111827] shadow-sm">
            <Filter className="w-4 h-4 text-[#111827]" />
            <span>All Judges</span>
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="flex-1 px-8 pb-10">
        <div className="bg-white rounded-2xl border border-[#E5E7EB]">
          <TableComponent
            DATA={panelData}
            // @ts-ignore
            COLUMNS={PresidentPanelsColumns}
            sorting={sorting}
            setSorting={setSorting}
          />
        </div>
      </div>
    </div>
  );
}

export default Panels;
